import { PRIMARY_OUTLET, UrlTree } from '@angular/router';

export const MOBILE_VIEW_QUERY = '(max-width: 900px)';

export const MOBILE_NAVIGATION_ITEMS = [
    { path: '/io-test/equipments', label: 'Equipments', icon: 'technical-review-1' },
    { path: '/io-issues/issues', label: 'Issues', icon: 'wrench-tool' }
] as const;

export function isMobileNavigationUrl(url: UrlTree): boolean {
    const segments = url.root.children[PRIMARY_OUTLET]?.segments ?? [];
    const path = '/' + segments.map(segment => segment.path).join('/');
    return MOBILE_NAVIGATION_ITEMS.some(item => item.path === path);
}